<form #form="ngForm">
  <p-fieldset legend="{{subtitle}}">
    <div class="p-fluid p-formgrid-del p-grid">
      <div class="p-field p-col-12 p-md-12 p-mb-0">
        <textarea pInputTextarea class="p-inputtext"
          id="rosterNote"
          name="rosterNote" 
          rows="8"
          [(ngModel)]="rosterEmployeeNote.note"></textarea>
      </div>
    </div>
    <div *ngIf="!!updateInfo" class="p-text-right text-small">
      {{updateInfo}}
    </div>
  </p-fieldset>

  <div class="modal-footer">
    <button pButton pRipple label="Save" 
            class="p-button p-button-raised p-button-success" type="button" 
            icon="fas fa-check"
            [disabled]="!hasFormChanged()"
            (click)="save(form);"></button>
    <button type="button" pButton pRipple class="p-button p-button-outlined" label="Cancel" icon="pi pi-times" (click)="cancel()"></button>
  </div>
</form>

  